/**
 * Font family for the social clip compositions (scenario-explainer, clip-v2).
 *
 * Do NOT call @remotion/google-fonts loadFont() at module load — it fetches
 * woff2 files from fonts.gstatic.com on every headless render/smoke still.
 * When the network blips (or the sandbox blocks outbound requests), Chrome
 * logs ERR_INTERNET_DISCONNECTED and text can fail to paint, which makes smoke
 * frames look blank/uniform and triggers false compile failures.
 *
 * A system stack keeps offline renders safe.
 */
export const VIDEO_FONT_FAMILY =
  'Inter, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif';
